export const accent = '#562894';
export const secondary = '#FE3F00';
